import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import VolcanoPlotTable from '../VolcanoPlotTable';
import ImageDownload from '../ImageDownload';
import DataDownload from '../DataDownload';

const apiHost = process.env.REACT_APP_API_HOST;
const apiProto = process.env.REACT_APP_API_PROTOCOL;

class VolcanoPlotResults extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchParameters: {},
      plotData: null,
    };
  }

  componentDidMount() {
    this.updateSearchParams();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.hash !== prevProps.match.params.hash) {
      this.updateSearchParams();
    }
  }

  updateResultData() {
    const { match } = this.props;
    const id = match.params.hash;
    const dataUrl = `${apiProto}://${apiHost}/nuclei/volcanoplot/data/${id}`;
    axios.get(dataUrl).then((response) => {
      this.setState({ plotData: response.data.slice(0, 10).map(n => n._row) });
    });
  }

  updateSearchParams() {
    const { match } = this.props;
    const id = match.params.hash;
    const searchUrl = `${apiProto}://${apiHost}/search/${id}`;
    axios.get(searchUrl).then((response) => {
      this.setState({ searchParameters: response.data });
      this.updateResultData(response.data);
    });
  }

  render() {
    const { match } = this.props;
    const id = match.params.hash;
    const { plotData, searchParameters } = this.state;

    // use the id to fetch the search parameters.
    // also use it to place the result image in the page
    // as returned by the api.
    const plotUrl = `${apiProto}://${apiHost}/nuclei/volcanoplot/image/${id}`;
    const dataUrl = `${apiProto}://${apiHost}/nuclei/volcanoplot/data/${id}`;

    return (
      <div className="row volcanoplot-results">
        <div className="col">
          <div className="card">
            <div className="card-header">
              Results
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h3>Parameters</h3>
                  <dl>
                    {searchParameters.comparison1 && ([
                      <dt key="label">Comparison 1</dt>,
                      <dd key="value">{searchParameters.comparison1.join(', ')}</dd>,
                    ])}
                    {searchParameters.comparison2 && ([
                      <dt key="label">Comparison 2</dt>,
                      <dd key="value">{searchParameters.comparison2.join(', ')}</dd>,
                    ])}
                  </dl>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <dl>
                    {searchParameters.fdr_cutoff && ([
                      <dt key="label">FDR Max</dt>,
                      <dd key="value">{searchParameters.fdr_cutoff}</dd>,
                    ])}
                    {searchParameters.sort_by && ([
                      <dt key="label">Sort Method</dt>,
                      <dd key="value">{searchParameters.sort_by}</dd>,
                    ])}
                    {searchParameters.de_mode && ([
                      <dt key="label">Differential Expresion Mode</dt>,
                      <dd key="value">{searchParameters.de_mode}</dd>,
                    ])}
                  </dl>
                </div>
                <div className="col-md">
                  <dl>
                    {searchParameters.lfc_cutoff && ([
                      <dt key="label">log2 Fold Change Minimum</dt>,
                      <dd key="value">{searchParameters.lfc_cutoff}</dd>,
                    ])}
                    {searchParameters.topgenes && ([
                      <dt key="label">Top number of genes to label</dt>,
                      <dd key="value">{searchParameters.topgenes}</dd>,
                    ])}
                  </dl>
                </div>
              </div>
              <div className="row">
                <div className="col-lg">
                  <img alt="VolcanoPlot of Results. Download below to get raw text data." src={plotUrl} />
                </div>
                <div className="col-lg">
                  { this.state.plotData && (<VolcanoPlotTable results={plotData} params={searchParameters} category="nuclei" />) }
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <ImageDownload id={id} plotUrl={plotUrl} />
                  <DataDownload id={id} dataUrl={dataUrl} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

VolcanoPlotResults.propTypes = {
  match: PropTypes.object.isRequired,
};

export default VolcanoPlotResults;



// WEBPACK FOOTER //
// ./src/components/Nuclei/VolcanoPlotResults.jsx